import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Sparkles, CheckCircle } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
export function CallToAction() {
  const {
    t
  } = useLanguage();
  return <section className="py-40 relative overflow-hidden bg-black" data-id="element-24">
      {/* Mesmerizing Animated Background */}
      <div className="absolute inset-0 overflow-hidden" data-id="element-25">
        <div className="absolute inset-0 bg-[#050505]" data-id="element-26"></div>

        {/* Animated Aurora Effect */}
        <motion.div animate={{
        opacity: [0.4, 0.6, 0.4],
        scale: [1, 1.1, 1],
        rotate: [0, 5, 0]
      }} transition={{
        duration: 10,
        repeat: Infinity,
        ease: 'easeInOut'
      }} className="absolute -top-[50%] -left-[20%] w-[150%] h-[150%] bg-gradient-to-br from-blue-900/30 via-purple-900/30 to-black blur-[100px]" data-id="element-27" />
        <motion.div animate={{
        opacity: [0.3, 0.5, 0.3],
        scale: [1.1, 1, 1.1],
        rotate: [0, -5, 0]
      }} transition={{
        duration: 15,
        repeat: Infinity,
        ease: 'easeInOut',
        delay: 1
      }} className="absolute -bottom-[50%] -right-[20%] w-[150%] h-[150%] bg-gradient-to-tl from-emerald-900/20 via-blue-900/20 to-black blur-[100px]" data-id="element-28" />

        {/* Stars / Particles */}
        <div className="absolute inset-0 bg-[url('https://grainy-gradients.vercel.app/noise.svg')] opacity-20 mix-blend-overlay" data-id="element-29"></div>
      </div>

      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center" data-id="element-30">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="inline-flex items-center gap-2 px-6 py-2 rounded-full bg-white/5 backdrop-blur-xl border border-white/10 text-white text-sm font-medium mb-10 shadow-[0_0_20px_-5px_rgba(255,255,255,0.1)]" data-id="element-31">
          <Sparkles className="w-4 h-4 text-yellow-300 animate-pulse" data-id="element-32" />
          <span className="tracking-wide uppercase text-xs" data-id="element-33">
            AI Website Builder v2.0
          </span>
        </motion.div>

        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.1
      }} className="text-5xl md:text-7xl lg:text-8xl font-bold text-transparent bg-clip-text bg-gradient-to-b from-white via-white to-white/50 mb-8 leading-tight tracking-tight" data-id="element-34">
          {t.cta.title}
        </motion.h2>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2
      }} className="text-xl md:text-2xl text-gray-400 mb-16 max-w-3xl mx-auto leading-relaxed font-light" data-id="element-35">
          {t.cta.subtitle}
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.3
      }} className="flex flex-col items-center gap-8" data-id="element-36">
          {/* Premium Glowing Button */}
          <motion.button whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} className="group relative px-12 py-6 bg-white text-black rounded-full font-bold text-xl overflow-hidden" data-id="element-37">
            {/* Button Glow */}
            <div className="absolute inset-0 bg-gradient-to-r from-blue-400 via-purple-400 to-blue-400 opacity-0 group-hover:opacity-100 transition-opacity duration-500 blur-xl" data-id="element-38" />

            {/* Button Content */}
            <div className="relative z-10 flex items-center gap-3" data-id="element-39">
              {t.cta.button}
              <ArrowRight className="w-6 h-6 group-hover:translate-x-1 transition-transform" data-id="element-40" />
            </div>

            {/* Shine Effect */}
            <div className="absolute inset-0 -translate-x-full group-hover:translate-x-full transition-transform duration-1000 bg-gradient-to-r from-transparent via-white/50 to-transparent skew-x-12" data-id="element-41" />
          </motion.button>

          <div className="flex flex-wrap justify-center gap-8 text-sm text-gray-500 font-medium" data-id="element-42">
            <span className="flex items-center gap-2 px-4 py-2 rounded-full bg-white/5 border border-white/5" data-id="element-43">
              <CheckCircle className="w-4 h-4 text-green-500" data-id="element-44" />
              {t.cta.noCard}
            </span>
            <span className="flex items-center gap-2 px-4 py-2 rounded-full bg-white/5 border border-white/5" data-id="element-45">
              <CheckCircle className="w-4 h-4 text-green-500" data-id="element-46" />
              {t.cta.free}
            </span>
          </div>
        </motion.div>
      </div>
    </section>;
}